// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__7WCFi","notes":"Notes_notes__3Lwqj"};